<template>
  <div class="section_header">
    <div class="section_header_bg" :style="bgSrc">
      <h1 ref="title" class="title">{{ title }}</h1>
    </div>
  </div>
</template>
<script>
export default {
  name: "SectionHeader",
  props: {
    title: String,
    imgSrc: String,
  },
  data() {
    return {
      bgSrc: {
        backgroundImage: `url(${require(`@/assets/images/${this.imgSrc}`)})`,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.section_header {
  height: 227px;
  margin-bottom: 2em;
  @media (max-width: 900px) {
    height: 160px;
  }
  &_bg {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 3em;
    background-size: cover;
    background-position: center;
    @media (max-width: 900px) {
      padding: 3em 0;
    }
    h1 {
      font-family: Garland;
      font-size: 100px;
      color: #ffffff;
      text-align: center;
      line-height: 75px;
      font-weight: 400;
      @media (max-width: 900px) {
        font-size: 80px;
        line-height: 0.7;
      }
      @media (max-width: 500px) {
        font-size: 50px;
        line-height: 1;
      }
    }
  }
}
</style>
